import React from 'react';

export default props => {

  return (
    <div className="Outmost"  style={{ justifyContent: 'center', alignItems: 'center' }}>
      <h2 style={{ color: '#bbb' }}>uBelong Lite</h2>
    </div>
  );
}